import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { EntitySchemaListView } from './entity-schema-list.view';
import { EntitySchemaDataService } from '../entity-schema.data';

@observer
export class EntitySchemaListController extends React.Component<ControllerProps<{}>, {}> {
	@observable
	dataService: EntitySchemaDataService;

	@resolve
	toast: ToastNotifications;

	constructor(props: Readonly<ControllerProps<{}>>) {
		super(props);
	}

	componentDidMount() {
		this.props.setBusy(true);

		this.dataService = EntitySchemaDataService.make();
		this.loadData()
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	private async loadData(): Promise<void> {
		this.dataService.addSorting('name', 'asc', true);
		this.dataService.addFilter('type', 'eq', 0);
		this.dataService.addFilter('isEditable', 'eq', 1);
		await this.dataService.load(query => query);
	}
	
	handleItemDoubleClick = (item: EntitySchemaSummary) => {
		this.props.history.push(`/general/entity-schemas/${item == null ? 'new' : item.name}`);
	};

	render() {
		if (this.dataService == null) {
			return null;
		}

		return (
			<EntitySchemaListView
				model={this.dataService}
				setBusy={this.props.setBusy}
				onItemDoubleClicked={this.handleItemDoubleClick}
				{...this.props}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/entity-schemas/list/entity-schema-list.controller.tsx